const { warn, } = require('application/console');
import routerActions from 'actions/routerActions';
import { isEmbededPost, } from 'application/pageDataObject';
import { create as makeEmptyObj, } from 'utils/object';
import { isFunction, } from 'utils/fn';
import m, { trust as trustHtmlString, } from 'mithril';
import { registerUtils, registerInNamespace, } from 'application/nm';


function coerceToJson(xhr){
  try {
    JSON.parse(xhr.responseText);
    return xhr.responseText;
  } catch (ex) {
    const errorResponse = {
      xhr,
      exception: ex,
      code: xhr.status,
      body: xhr.responseText,
    };
    warn("mithril ajax request error:", ex.stack, errorResponse);
    return JSON.stringify(errorResponse);
  }
}

function addTimeoutForRequest(originalOptions) {
  const originalConfigFunction = originalOptions.config;
  return function configureOptions(xhr, options) {
    xhr.timeout = options.timeout;
    if (isFunction(originalConfigFunction)) {
      return originalConfigFunction.apply(this, arguments);
    }
    return xhr;
  };
}

const mithrilHelpers = Object.assign(makeEmptyObj(), {

  createElementWithCallback: function createElementWithCallback(...args){
    let selector = arguments.length === 1 ? 'div' : args.shift();
    let { children, callback, attributes, } = args.pop();
    let attrs = {
      config: callback,
    };
    Object.assign(attrs, attributes);
    m.redraw.strategy("diff");
    return m(
      selector,
      attrs,
      children
    );
  },
  urlWithQs: function createUrlWithQuerystring(url, qs, delimiter = '?'){
    return `${ url }${ delimiter }${ m.route.buildQueryString(qs) }`;
  },
  safeRequest: function callMithrilRequest(options){
    if (options.timeout) {
      options.config = addTimeoutForRequest(options);
    }
    if (!options.deserialize) { // if deserialize is not given, then by default mithril expect a JSON response
      options.extract = options.extract || coerceToJson;
    }
    if (options.url.includes('undefined')) {
      warn("safeRequest options.url includes the string 'undefined'. Most likely a mistake, isn't it?", options);
    }
    return m.request(options);
  },

  routeAndDispatch: function routeAndDispatch(url){
    //Replace current history entry instead of adding new one only for embed posts
    let shouldReplaceCurrentHistory = isEmbededPost;
    m.route(url, {}, shouldReplaceCurrentHistory);
    routerActions.routeChanged(url);
  },

  trustHtmlString,

});

registerInNamespace({ m, });
registerUtils({ mithrilHelpers, });

export default { mithrilHelpers, m };


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/mithril.js